import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
// import editor from "../../Assets/Projects/codeEditor.png";
// import atmos from "../../Assets/Projects/chatify.png";
// import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few <b className="purple"> amazing </b> projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              // imgPath={atmos}
              isBlog={false}
              title="Atmos"
              description="Atmos is an air quality prediction app that helps you plan your day with confidence. It's uses time series forecasting and prediction algorithms built over tensorflow and pytorch using streamlit SDK "
              ghLink="https://github.com/gigDevelopment10/atmos"
              demoLink="https://chatify-49.web.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              // imgPath={bitsOfCode}
              isBlog={false}
              title="Neural Funk"
              description="Neural Funk is a deep learning package developed from scratch to automate the task of backpropagation and model training for ML engineers. Written in Python and Numpy, it simplifies the process of creating and training complex neural networks, making it easier for developers to build powerful AI models."
              ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              // imgPath={editor}
              isBlog={false}
              title="Green Mailz"
              description="Green Mails is a recommendation system that aims to reduce carbon footprint by suggesting users to delete junk emails that are no longer required. It uses a hybrid approach of content-based and collaborative filtering to recommend emails to users."
              ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
